import { InjectionToken } from '@angular/core';
import { AppMenuItem } from './app-menu-item';

export const APP_MENU = new InjectionToken<AppMenuItem[]>('menu');

export const appMenuProvider = { provide: APP_MENU, useValue: [] };
